import { render, staticRenderFns } from "./SearchAreaPopup.vue?vue&type=template&id=20647d86&scoped=true&"
import script from "./SearchAreaPopup.vue?vue&type=script&lang=ts&"
export * from "./SearchAreaPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SearchAreaPopup.vue?vue&type=style&index=0&id=20647d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20647d86",
  null
  
)

export default component.exports